import { useEffect, useState } from 'react';
import ViewOrderTable from './ViewOrderTable';
import { OrderItem } from '../../Models/OrderItem';
import OrderApi from '../../Api/OrderApi';
import { Order } from '../../Models/Order';
import Loader from '../Common/Loader';
import { toast } from 'react-toastify';
import { formatNumbers } from '../../Utils';
import { Button } from 'flowbite-react';
import { Equipment } from '../../Models/Equipment';
import { useAppSelector } from '../../Reducers/store';
import { SavedItem } from '../../Models/SavedItem';
import SavedItemsTable from './SavedItemsTable';
import { Link } from 'react-router-dom';

export default function ViewOrder() {
  const { userModel } = useAppSelector((state) => state.user);
  const [loading, setIsLoading] = useState<boolean>();
  const [orderData, setOrderData] = useState<Order | null>(null);
  const [savedData, setSavedData] = useState<SavedItem[] | null>(null);

  const getOrder = () => {
    setIsLoading(true);
    //localStorage.setItem('openOrderId', '0');
    const openOrderId = 0;
    OrderApi.getOrder(openOrderId)
      .then((res) => {
        if (res.data.id > 0) {
          setOrderData(res.data);
          localStorage.setItem('openOrderId', res.data.id.toString());
          OrderApi.getOrderItemsCount(openOrderId)
            .then((res) => {
              if (res.data !== null) {
                localStorage.setItem('orderItemsCount', res.data.toString());
                window.dispatchEvent(new Event('updateOrderItemCount'));
              }
            })
            .catch((err) => {
              setIsLoading(false);
            });
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };
  const getSavedItems = () => {
    if (userModel) {
      setIsLoading(true);
      OrderApi.getSavedItems(userModel.id)
        .then((res) => {
          setSavedData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    getOrder();
    getSavedItems();
  }, []);

  function removeFromCart(id: number) {
    const shouldRemove = window.confirm(
      'Are you sure you want to remove this from your cart?'
    );
    if (shouldRemove) {
      OrderApi.deleteOrderItem(id)
        .then((res) => {
          if (res.data.success) {
            toast.success('Item removed');
            getOrder();
          }
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
    }
  }

  function removeFromSaved(id: number) {
    const shouldRemove = window.confirm(
      'Are you sure you want to remove this from your saved items?'
    );
    if (shouldRemove) {
      OrderApi.deleteSavedItem(id)
        .then((res) => {
          if (res.data.success) {
            toast.success('Item removed');
            getSavedItems();
          }
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
    }
  }

  function moveToCart(item: SavedItem) {
    const openOrderId =
      localStorage.getItem('openOrderId') &&
      Number(localStorage.getItem('openOrderId')) >= 0
        ? Number(localStorage.getItem('openOrderId'))
        : 0;
    if (openOrderId > 0) {
      OrderApi.moveSavedItemToCart(item, openOrderId)
        .then((res) => {
          if (res.data.success) {
            toast.success('Item saved');
            getOrder();
            getSavedItems();
          }
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
    }
  }

  function saveForLater(equipment: Equipment) {
    OrderApi.saveItem(equipment)
      .then((res) => {
        if (res.data.success) {
          toast.success('Item saved');
          getOrder();
          getSavedItems();
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  }

  function updateItemQuantity(item: OrderItem, quantity: number) {
    item.quantity = quantity;
    OrderApi.updateOrderItemQuantity(item)
      .then((res) => {
        if (res.data.success) {
          getOrder();
        }
      })
      .catch((err) => {});
  }

  return (
    <>
      <div className='w-full mt-4'>
        <div className='container mx-auto p-2'>
          <div className='mb-2 border-b-2 flex justify-between'>
            <h1 className='text-gray-900 font-bold text-4xl'>Cart:</h1>
            {orderData && (
              <div className='flex gap-3'>
                <div className='flex gap-3 font-bold text-2xl items-end'>
                  <div>Total: </div>
                  <div>
                    $
                    {formatNumbers(
                      orderData.orderItems?.reduce((acc, item) => {
                        const equipment = item.equipment;
                        const isTrade = equipment?.oemvendor?.startsWith('1');
                        const price = isTrade
                          ? equipment?.tradePrice ?? 1
                          : equipment?.special1Price ?? 1;
                        return acc + price * item.quantity;
                      }, 0)
                    )}
                  </div>
                </div>
                <div>
                  <Link to={'/orders/checkout'}>
                    <Button type='button' className='buttonMain'>
                      Checkout
                    </Button>
                  </Link>
                </div>
              </div>
            )}
          </div>
          <div className='relative'>
            {loading && <Loader />}
            <div className='h-[calc(100vh-142px)] md:h-[calc(100vh-210px)] overflow-y-auto'>
              {orderData && (
                <div>
                  <ViewOrderTable
                    data={orderData?.orderItems ?? []}
                    removeFromCart={removeFromCart}
                    saveForLater={saveForLater}
                    updateItemQuantity={updateItemQuantity}
                  />
                </div>
              )}
              {!orderData && <div>Your order is empty</div>}
              {savedData && savedData.length > 0 && (
                <div className='pt-10 border-t-2'>
                  <div className='mb-2 flex justify-between'>
                    <h1 className='text-gray-900 font-bold text-4xl'>
                      Saved Items:
                    </h1>
                  </div>
                  <SavedItemsTable
                    data={savedData ?? []}
                    removeFromSaved={removeFromSaved}
                    moveToCart={moveToCart}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
